module.exports = __webpack_public_path__ + "img/scale_big.ccb6aa5f.svg";